<div class="ivd">

  @if (!detail) {
    <div class="ivd__empty">
      <mat-spinner diameter="24" />
    </div>
  }

  @if (detail) {

    <!-- Section header -->
    <div class="ivd__header">
      <!-- <span class="ivd__label">Documents</span>
      <div class="ivd__chip ivd__chip--{{ consolidatedStatusClass }}">
        <mat-icon class="ivd__chip-icon">{{ consolidatedStatusIcon }}</mat-icon>
        {{ consolidatedStatus }}
      </div> -->
    </div>

    <!-- Three columns, one per document type -->
    <div class="ivd__grid">

      @for (key of SLOT_KEYS; track key) {
        <div class="ivd__col">

          <!-- Image viewer — fixed height, no layout shifts -->
          <itfg-identity-document-viewer
            [document$]="slots[key].subject$"
            [client]="client"
            [label]="SLOT_CONFIGS[key].label"
            [status]="detail[SLOT_CONFIGS[key].statusKey]"
            [showSubmitButton]="false">
          </itfg-identity-document-viewer>

          <!-- ── Document list panel ── -->
          <div class="ivd__list-panel">

            <div class="ivd__list-head">
              <span class="ivd__list-label">Uploaded</span>

              <div class="ivd__list-actions">
                <!-- Upload button -->
                <label
                  class="ivd__upload-btn"
                  [class.ivd__upload-btn--loading]="slots[key].uploading"
                  [matTooltip]="'Upload new ' + SLOT_CONFIGS[key].label">
                  @if (slots[key].uploading) {
                    <mat-spinner diameter="12" />
                  } @else {
                    <mat-icon>upload</mat-icon>
                  }
                  <input
                    type="file"
                    accept="image/*,application/pdf"
                    class="ivd__file-input"
                    [disabled]="slots[key].uploading"
                    (change)="onFileSelected(key, $event)" />
                </label>

                <!-- Disabled when the selected doc is already linked to this verification -->
                <button
                  mat-flat-button
                  color="primary"
                  class="ivd__submit-btn"
                  [disabled]="!slots[key].selectedId || isVerificationDoc(key, slots[key].selectedId)"
                  (click)="submitDocument(key)"
                  [matTooltip]="isVerificationDoc(key, slots[key].selectedId)
                    ? 'Already submitted to this verification'
                    : 'Submit selected document to this verification'">
                  <mat-icon>send</mat-icon> Submit
                </button>
              </div>
            </div>

            <!-- Empty list -->
            @if (!loadingLists && !slots[key].list.length) {
              <span class="ivd__list-empty">No documents uploaded</span>
            }

            <!-- List loading skeleton -->
            @if (loadingLists) {
              <div class="ivd__list-item ivd__list-item--skeleton">
                <div class="ivd__skeleton ivd__skeleton--icon"></div>
                <div class="ivd__skeleton ivd__skeleton--text"></div>
              </div>
            }

            <!-- Document rows -->
            @for (doc of slots[key].list; track trackById($index, doc)) {
              <div
                class="ivd__list-item"
                [class.ivd__list-item--selected]="slots[key].selectedId === doc.id"
                [class.ivd__list-item--verification-valid]="isVerificationDoc(key, doc.id) && verificationDocStatusClass(key) === 'valid'"
                [class.ivd__list-item--verification-validating]="isVerificationDoc(key, doc.id) && verificationDocStatusClass(key) === 'validating'"
                [class.ivd__list-item--verification-invalid]="isVerificationDoc(key, doc.id) && verificationDocStatusClass(key) === 'invalid'"
                (click)="selectDocument(key, doc)">

                <mat-icon class="ivd__list-icon">
                  {{ isVerificationDoc(key, doc.id) ? 'verified' : 'description' }}
                </mat-icon>

                <div class="ivd__list-meta">
                  <span class="ivd__list-name" [matTooltip]="doc.name">
                    {{ doc.name || ('doc #' + doc.id) }}
                  </span>
                  @if (doc.createdAt) {
                    <span class="ivd__list-date">{{ doc.createdAt | date:'dd.MM.yy HH:mm' }}</span>
                  }
                </div>

              </div>
            }

          </div>
        </div>
      }

    </div>
  }

</div>